import React from 'react';
import { withStyles, makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import CreateIcon from '@material-ui/icons/Create';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      padding: theme.spacing(2),
    },
  })
);

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);

function orikomiCreateData(val, size, tax) {
  val = val.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  size = size.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  tax = tax.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  return { val, size, tax };
}
function warimashiCreateData(val, tax) {
  val = val.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  tax = tax.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  return { val, tax };
}
function kyuukanCreateData(date, arrow, reason) {
  date = date.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  reason = reason.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  return { date, arrow, reason };
}
const orikomiRows = [
  orikomiCreateData('A・B4判以下', '新聞１／２ページの大きさ以下', '3.96円（税抜3.6円）'),
  orikomiCreateData('A・B3判まで', '１ページの大きさまで', '6.05円（税抜5.5円）'),
  orikomiCreateData('A・B2判まで', '新聞２ページの大きさまで', '11.55円（税抜10.5円）'),
  orikomiCreateData('A・B1判まで', '新聞４ページの大きさまで', '22.00円（税抜20.0円）'),
  orikomiCreateData('ハガキ', 'ハガキ及び同サイズ', '4.62円（税抜4.2円）'),
];
const warimashiRows = [
  warimashiCreateData('厚物（110kg以上）', '1.10円増'),
  warimashiCreateData('のり付け', '1.10円増'),
  warimashiCreateData('ホチキス', '1.10円増'),
  warimashiCreateData('シール貼', '2.20円増'),
  warimashiCreateData('変　　形', '基本の5割増'),
];
const kyuukanRows = [
  kyuukanCreateData("1月 2日（火）", <ArrowRightAltIcon />, "休刊"),
  kyuukanCreateData("2月13日（火）", <ArrowRightAltIcon />, "休刊"),
  kyuukanCreateData("3月18日（月）", <ArrowRightAltIcon />, "休刊"),
  kyuukanCreateData("4月15日（月）", <ArrowRightAltIcon />, "休刊"),
  kyuukanCreateData("5月13日（月）", <ArrowRightAltIcon />, "休刊"),
  kyuukanCreateData("6月10日（月）", <ArrowRightAltIcon />, "休刊"),
  kyuukanCreateData("7月16日（火）", <ArrowRightAltIcon />, "休刊"),
  kyuukanCreateData("8月19日（月）", <ArrowRightAltIcon />, "休刊"),
  kyuukanCreateData("9月 9日（月）", <ArrowRightAltIcon />, "休刊"),
  kyuukanCreateData("10月15日（火）", <ArrowRightAltIcon />, "休刊"),
  kyuukanCreateData("11月11日（月）", <ArrowRightAltIcon />, "休刊"),
  kyuukanCreateData("12月 9日（月）", <ArrowRightAltIcon />, "休刊"),
];

function FlyerDetail() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            折込広告に関する規定及び営業案内（令和２年４月改定）
          </Typography>
          <Box my={4}>
            <dl>
              <dt>折込出来ない折込広告について</dt>
              <dd>
                <ul>
                  <li>広告主の名称、所在地、電話番号等の表示のないもの</li>
                  <li>新聞本紙と混同・誤認されると思われるもの</li>
                  <li>虚偽広告により誤認されるもの。また、「最高・最大級・日本一」の表示など、事実と異なる誇大・不当表示表現で読者に不利益を与えると思われるもの</li>
                  <li>通貨・紙幣又は、郵便切手類の模造・複写をしたもの</li>
                  <li>「金券・懸賞の応募券・抽選券・福引参加券」などが印刷されているもの、および読者の射幸心を煽るようなもの。ただし、クーポン券（割引券・見本請求券・資料請求券）の印刷されているものは、折込できます</li>
                  <li>
                    金融・貸金業に関するものは、下記の条件が満たされていないもの
                    <ul>
                      <li>折込地域の知事登録を済ませている</li>
                      <li>上記の登録番号が記載されている</li>
                      <li>実質年利を明記した貸付利率が記載されている</li>
                    </ul>
                  </li>
                  <li>不動産の表示に関する公正競争規約の必要表示事項の守られていないもの</li>
                  <li>新聞業における公正競争規約等、諸法規に触れると思われるもの</li>
                  <li>選挙に関するもの。ただし、選挙管理委員会の「証紙」を貼付したもの又は、承認番号のあるものは除く</li>
                  <li>個人・各種団体を問わず、意見広告を記載したもの</li>
                  <li>名誉毀損・プライバシーの侵害、中傷、ひぼう等法律違反の恐れのあるもの</li>
                  <li>広告に品位がなく公序良俗を乱すようなものや、内容の不明瞭なもの</li>
                </ul>
                <div class="fs90 text-danger line150 text-left">
                  ※上記以外でも、判断が難しいものは当センターで協議の上、決定いたしますので事前にお問い合わせください。<br/>
                </div>
              </dd>
            </dl>
          </Box>
          <Box my={4}>
            <dl>
              <dt>申込・納品の締切時間</dt>
              <dd>
                <ul>
                  <li>折込の申込は、当折込センター所定の「折込広告申込書」をご利用くださいますようお願いいたします。</li>
                  <li>折込の申込・折込広告の納品はいずれも、折込日の３日前の午後４時です。ただし、土・日曜日、祝日を除く当折込センターの営業日換算となります。</li>
                  <li>休日が続く場合、順次繰上げとなりますのでご注意下さい。</li>
                </ul>
              </dd>
            </dl>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            折込料金
          </Typography>

          <Box my={4}>
            <dl>
              <dt><ArrowRightIcon /> 基本料金(各１枚につき)</dt>
              <dd>
                <Box p={1} textAlign="center">
                  <Paper>
                    <TableContainer component={Paper}>
                      <Table className={classes.table} aria-label="customized table">
                        <TableHead>
                          <TableRow>
                            <StyledTableCell align="center">種類</StyledTableCell>
                            <StyledTableCell align="center">大きさ目安</StyledTableCell>
                            <StyledTableCell align="center">料金</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {orikomiRows.map(row => (
                            <StyledTableRow key={row.val}>
                              <StyledTableCell component="th" scope="row" align="center">
                                {row.val}
                              </StyledTableCell>
                              <StyledTableCell align="center">{row.size}</StyledTableCell>
                              <StyledTableCell align="center">{row.tax}</StyledTableCell>
                            </StyledTableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Box p={3} textAlign="left">
                      {/*                       
                      <Typography className="font-weight-bold my-1" variant="subtitle1" component="div">
                        <CreateIcon />料金計算例（B4)
                      </Typography>
                      <div className="fs120 font-weight-bold my-1">
                        1,500枚 × 3.3円 × 1.10 ＝ 5,445円
                      </div>
                       */}
                      <div class="fs90 text-danger line150 mt-3">
                        ※Ｂ４判を超えるものは新聞1/2ページの大きさ以下に折ったものに限ります。
                      </div>
                    </Box>
                  </Paper>
                </Box>
              </dd>
            </dl>
          </Box>

          <Box my={4}>
            <dl>
              <dt><ArrowRightIcon /> 割増料金</dt>
              <dd>
                <Box p={1} textAlign="center">
                  <Paper>
                    <TableContainer component={Paper}>
                      <Table className={classes.table} aria-label="customized table">
                        <TableHead>
                          <TableRow>
                            <StyledTableCell align="center">種類</StyledTableCell>
                            <StyledTableCell align="center">料金（税込）</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {warimashiRows.map(row => (
                            <StyledTableRow key={row.val}>
                              <StyledTableCell component="th" scope="row" align="center">
                                {row.val}
                              </StyledTableCell>
                              <StyledTableCell align="center">{row.tax}</StyledTableCell>
                            </StyledTableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Box>
              </dd>
            </dl>
          </Box>

          <Box my={4}>
            <dl>
              <dt><ArrowRightIcon /> お申込内容の変更やキャンセル</dt>
              <dd>
                <ul>
                  <li>締切日時前であればいつでもご変更可能です。</li>
                  <li>新聞販売店へ発送後のキャンセルは別途料金が発生します。組込作業後はキャンセル不可となります。</li>
                </ul>
              </dd>
              <dt><ArrowRightIcon /> 新型コロナウイルス感染拡大に伴う折込広告の取り扱いについて</dt>
              <dd>
                　感染拡大が懸念される新型コロナウイルス感染症につきまして、折込広告のお届けへの影響も否定できない状況となっております。あらかじめ対策は講じておりますが、仮に弊社において感染者が発生した場合、折込広告のお届けが大幅に遅れたり、配達ができないこともございます。また、お預かりしたチラシが消毒・廃棄の対象となることも想定されますので、あらかじめご了承ください。<br />
                　取引先各位におかれましては、大変ご心配ご迷惑をおかけいたしますが、有事の際の対応につきまして、何卒ご理解のほどよろしくお願いいたします。<br />
              </dd>
              <dt><ArrowRightIcon /> 災害時の免責について</dt>
              <dd>
                　大規模な災害や不可抗力による事故や事変が発生した場合、ライフラインや通信網の遮断、交通規制、避難などにより、ご依頼いただいた折込広告の一部、または全部が実施不能となる事態が考えられます。<br />
                　以上のことから災害時には「災害時の免責」を適用させていただきます。<br />
                　ご不便ご迷惑をおかけすることになりますが、ご理解の上お申し込みいただきますようお願い申し上げます。<br />
                <div class="font-weight-bold">【適用となる災害等】</div>
                <ul>
                  <li>大地震</li>
                  <li>津波</li>
                  <li>水害</li>
                  <li>大雪</li>
                  <li>火災、爆発事故</li>
                  <li>ライフラインや通信網の遮断</li>
                  <li>新型インフルエンザなどの感染症の発生</li>
                  <li>土砂崩れ</li>
                  <li>災害等にともなう交通規制、避難勧告</li>
                  <li>噴火、山林火災</li>
                  <li>放射能汚染</li>
                  <li>その他の災害</li>
                </ul>
                <div class="font-weight-bold">【災害等の免責】</div>
                　災害により新聞発行本社、新聞販売店及び、それに伴う輸送手段のいずれかの機能が停止した場合、その機能が復旧するまで、一部またはすべての地域で折込ができない場合や、折込の中止が出来ない場合がございます。<br />
                　上記の事態が発生した場合、可能な限り通常業務維持に努めますが、新聞折込や中止が出来なかった場合、責任の免除をお願いすることになりますので、あらかじめご了承いただきますようお願い申し上げます。<br />
              </dd>
              <dd>
                <Paper>
                  <Box p={2}>
                    <Typography className="font-weight-bold my-1" variant="subtitle1" component="h2">
                      【取引先銀行】
                    </Typography>
                    青森銀行八戸支店　（普）１１７５７７<br/>
                    みちのく銀行八戸中央支店　（普）３４０１６５１<br/>
                    青い森信用金庫本店　（普）３９１２１２<br/>
                    <Box p={1} textAlign="left">
                        ※受付時間：午前９時30分～午後５時30分（平日のみ）
                    </Box>
                  </Box>

                  <Box p={2}>
                    <Typography className="font-weight-bold my-1" variant="subtitle1" component="h2">
                      【口座名義人】
                    </Typography>
                    （株）デーリー東北新聞社折込センター
                    <Box p={1} textAlign="left">
                      <div class="fs90 text-danger line150">
                        ※お支払は前金にてお願い致します
                      </div>
                    </Box>
                  </Box>
                </Paper>
              </dd>
            </dl>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            新聞休刊により折込できない日【2024年】
          </Typography>
          <dl>
            <dd>
              <Box p={1} textAlign="center">
                <Paper>
                  <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table">
                      <TableBody>
                        {kyuukanRows.map(row => (
                          <StyledTableRow key={row.val}>
                            <StyledTableCell component="th" scope="row" align="center">
                              {row.date}
                            </StyledTableCell>
                            <StyledTableCell align="center">{row.arrow}</StyledTableCell>
                            <StyledTableCell align="center">{row.reason}</StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Box p={3} textAlign="left">
                    <div class="fs90 text-danger line150">
                      ※新聞休刊を変更することがあります。約１カ月前に決定しますので、お問い合わせ下さい。<br/>
                      ※選挙開票翌日の新聞製作が大幅に遅れると予想される場合は、折込をお断りすることもあります。予めご了承願います。<br/>
                    </div>
                  </Box>
                </Paper>
              </Box>
            </dd>
          </dl>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            お問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北新聞社 読者局 折込開発部（折込センター）</dt>
            <dd>
              〒031-0072　青森県八戸市城下二丁目４－４<br/>
              <PhoneEnabledIcon /> 0178-46-3195<br/>
              <i className="fas fa-fax mx-1"></i> 0178-44-1734<br/>
              <MailOutlineIcon /> <a href="mailto:orikomi@daily-tohoku.co.jp">orikomi@daily-tohoku.co.jp</a>
            </dd>
          </dl>
        </Box>

      </div>
    </div>
  );
}

export default FlyerDetail;
